import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {Item} from "../../../../models/Item";
import {ItemManagerService} from "../../../../services/itemManager/item-manager.service";
import {AbstractObserver} from "../../../AbstractObserver/AbstractObserver";
import {counter} from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-simple-component',
  templateUrl: './object-array.component.html',
  styleUrls: ['./object-array.component.scss']
})
export class ObjectArrayComponent extends AbstractObserver implements OnInit {

  @Input() item: Item;
  @ViewChild('gapInputX', {static: false}) gapInputX;
  @ViewChild('gapInputY', {static: false}) gapInputY;
  @ViewChild('counterInputX', {static: false}) counterInputX;
  @ViewChild('counterInputY', {static: false}) counterInputY;

  static OBJECT_ARRAY_COUNTER_X = 'OBJECT_ARRAY_COUNTER_X';
  static OBJECT_ARRAY_COUNTER_Y = 'OBJECT_ARRAY_COUNTER_Y';
  static OBJECT_ARRAY_COUNTER_SUBJECT = 'OBJECT_ARRAY_COUNTER_SUBJECT';
  static OBJECT_ARRAY_CONFIG_SUBJECT = 'OBJECT_ARRAY_CONFIG_SUBJECT';

  public Yiit = Yiit;
  public counterX:number = null;
  public counterY:number = null;
  // public selectedDirection:string = null;
  private _gapNumX:number = null;
  private _gapNumY:number = null;
  get gapX(){
    return (this._gapNumX == undefined || null) ? 0 : this._gapNumX;
  }
  get gapY(){
    return (this._gapNumY == undefined || null) ? 0 : this._gapNumY;
  }

  public directionProps = {x: this.Yiit.t('Horizontal'), y: this.Yiit.t('Vertical')};
  public isChanged = false;
  public isLoaded = false;

  constructor(private cd: ChangeDetectorRef, private im: ItemManagerService) { super();}

  ngOnInit() {
    //if copy item then override to parentItem in order to interact rows/cols fields properly
    if (this.item.config.isCopy){
      this.item = this.im.getItemById(this.item.config.getCopyParentId);
    }


    this.updateSwitchedProperty();
    this.subscribeToObservable(this.item.getCounter(ObjectArrayComponent.OBJECT_ARRAY_COUNTER_X), ((value) => {
      this.counterX = value+1;
      this.cd.detectChanges();
    }));

    this.subscribeToObservable(this.item.getCounter(ObjectArrayComponent.OBJECT_ARRAY_COUNTER_Y), ((value) => {
      this.counterY = value+1;
      this.cd.detectChanges();
    }));

    this.subscribeToObservable(this.item.getSubject(ObjectArrayComponent.OBJECT_ARRAY_CONFIG_SUBJECT), ((_config)=>{
      this.updateValues();
    }));

    this.subscribeToObservable(this.item.config.subject, ()=>{
      this.updateSwitchedProperty();
    });

    this.updateValues();

    this.subscribeToObservable(this.item.getObservable('ObjectArrayLoadingStatus'), (status)=>{
      this.isLoaded = status;
      this.cd.detectChanges();
    })
  }

  // private setCounterByCopies(_counter, val:number){
  //   _counter = val+1;
  //   this.cd.detectChanges();
  // }

  private updateSwitchedProperty(){
    this.isChanged = this.item.config.getInputProp('__objectArray', 'is_changed');
    this.cd.detectChanges();
  }

  public isItemCopied(){
    return this.item.config.isCopy;
  }

  private updateValues(){
    var gapMetersInputVal = this.item.config.getInputProp('__objectArrayGap', 'value');
    if (!gapMetersInputVal){
      gapMetersInputVal = JSON.stringify({x: 0, y:0});
    }
    var gapMeters;
    try {
      gapMeters = JSON.parse(gapMetersInputVal);
      for (let i in gapMeters){
        gapMeters[i] = parseFloat(gapMeters[i]);
      }
    }
    catch (e){
      console.error('gapMetersInputVal error', e);
      return;
    }


    if (gapMeters.x<0){
      gapMeters.x = 0;
    }

    if (gapMeters.y<0){
      gapMeters.y = 0;
    }
    this._gapNumX = gapMeters.x;
    this._gapNumY = gapMeters.y;
    // this.selectedDirection = this.item.config.copyDirection;
    this.cd.detectChanges();
  }

  onChangeCounter(event, direction){
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();
    let value = parseFloat(event.target.value);
    let counterInput = (direction == 'x') ? this.counterInputX : this.counterInputY;
    if (isNaN(value) || value <= 0){
      value = 1;
    }
    if (value > 10){
      value = 10;
    }
    if (value % 1 != 0){
      value = Math.round(value);
    }
    counterInput.nativeElement.value = value;
    let xValue = this.counterInputX.nativeElement.value;
    let yValue = this.counterInputY.nativeElement.value;
    this.isLoaded = true;
    this.item.getSubject(ObjectArrayComponent.OBJECT_ARRAY_COUNTER_SUBJECT).next({x: xValue, y: yValue});
    this.cd.detectChanges();
  }

  onChangeGap(value, direction){
    value = parseFloat(value);
    let gapInput = (direction == 'x') ? this.gapInputX : this.gapInputY;
    if ( value< 0 || isNaN(value)){
      value = 0;
    }

    let valueNumber = value.toString().split(/[.,]/)[0]
    let decimalNumber = value.toString().split(/[.,]/)[1] || '';

    if (valueNumber && valueNumber.length > 3){
      valueNumber = parseFloat(valueNumber.substr(0, 3));
      value = parseFloat(valueNumber.toString()+'.'+decimalNumber.toString());
    }

    if (decimalNumber && decimalNumber.length > 3){
      decimalNumber = parseFloat(decimalNumber.substr(0, 3));
      value = parseFloat(valueNumber.toString()+'.'+decimalNumber.toString());
    }


    gapInput.nativeElement.value = value;
    let currentGap = {x: this.gapInputX.nativeElement.value, y:this.gapInputY.nativeElement.value};
    this.item.config.setInputValue('__objectArrayGap', 'value', JSON.stringify(currentGap));
    // this.item.config.copyGapInMeters = value;
    this.cd.detectChanges();
  }

  onChangeCopiesDirection(value){
    // this.item.config.copyDirection = value;
  }

}
